// extracted by mini-css-extract-plugin
export default {"selectorContainer":"CardMoveStep_selectorContainer__FakWc","text":"CardMoveStep_text__1xxWN","selector":"CardMoveStep_selector__goGMu"};